import { render, staticRenderFns } from "./city_v.vue?vue&type=template&id=08012ba9&scoped=true&"
import script from "./city_v.vue?vue&type=script&lang=js&"
export * from "./city_v.vue?vue&type=script&lang=js&"
import style0 from "./city_v.vue?vue&type=style&index=0&id=08012ba9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08012ba9",
  null
  
)

export default component.exports